import React from "react"
import { AccountPermissions, ProjectPermissions } from "client/store/utils"
import {
    TableWrapper,
    TableScroller,
    TableContentWrapper,
    TableRow,
    TableBottom,
    TableCellContent,
    CellType,
} from "../styled"
import {
    PermissionTableHeaderCell,
    PermissionTableCell,
} from "./styled"


export interface PermissionTableColumn extends CellType {
    field: string
    header: string
    formatter: (section: string, permissionId: string, permission: any) => any
}

export interface PermissionTableProps {
    columns: PermissionTableColumn[]
    section: string
    dataList: AccountPermissions | ProjectPermissions
    hiddenPermissions?: string[]
}

export const PermissionTable = ({
    columns = [],
    section = null,
    dataList = {},
    hiddenPermissions = [],
}: PermissionTableProps) => (
    <TableWrapper>
        <TableScroller>
            <TableContentWrapper>
                <thead>
                    <TableRow size="sm" noHover>
                        {
                            columns.map((column) => (
                                <PermissionTableHeaderCell
                                    key={column.field}
                                    cellWidth={column.cellWidth || null}
                                    cellMinWidth={column.cellMinWidth || null}
                                >
                                    <span>{column.header}</span>
                                </PermissionTableHeaderCell>
                            ))
                        }
                    </TableRow>
                </thead>
                <tbody>
                    {
                        Object.keys(dataList).map((permissionId) => {
                            if (hiddenPermissions.includes(permissionId)) return null

                            const permission = dataList ? dataList[permissionId] : null
                            if (!permission) return null
                            return (
                                <TableRow key={permissionId} size="fit" noHover>
                                    {
                                        columns.map((column) => (
                                            <PermissionTableCell
                                                key={column.field}
                                                cellWidth={column.cellWidth || null}
                                                cellMinWidth={column.cellMinWidth || null}
                                                centerAlign={column.centerAlign || null}
                                            >
                                                <TableCellContent fitContent>
                                                    { column.formatter(section, permissionId, permission) }
                                                </TableCellContent>
                                            </PermissionTableCell>
                                        ))
                                    }
                                </TableRow>
                            )
                        })
                    }
                </tbody>
            </TableContentWrapper>
        </TableScroller>
        <TableBottom />
    </TableWrapper>
)
